import { render, staticRenderFns } from "./AppLayoutMonitoramento.vue?vue&type=template&id=47baaafa&scoped=true"
import script from "./AppLayoutMonitoramento.vue?vue&type=script&lang=js"
export * from "./AppLayoutMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutMonitoramento.vue?vue&type=style&index=0&id=47baaafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47baaafa",
  null
  
)

export default component.exports